import React from "react";
import { Button, DatePicker, Panel } from "rsuite";
import Table from "../Table";
import { updateAdmin } from "../../store/modules/admin/actions";
import { useDispatch, useSelector } from "react-redux";
import { updateCliente } from "../../store/modules/cliente/actions";

export default function CarrosList() {
  const dispatch = useDispatch();
  const { form, components } = useSelector((state) => state.admin);
  
  const { carros } = useSelector((state) => state.reserva);
  const setComponent = (component, state) => {
    dispatch(
      updateAdmin({
        components: { ...components, [component]: state },
      })
    );
  };

  const CadastrarCarro = () => {
    dispatch(
      updateAdmin({
        behavior: "Cadastrar_carro",
      })
    );
    setComponent("drawer_carros", true);
  };

  return (
    <div className="d-flex flex-column m-0 p-0 col-12 col-xl-12 bg-white">
    <div className=" d-flex flex-column">
      <div className="d-flex flex-column  ">
        <Button
          color="green"
          appearance="primary"
          size="xs"
          onClick={() => CadastrarCarro()}
        >
          {" "}
          Cadastrar Carro
        </Button>
        <Table
          className="col-12 col-xl-12  "
          loading={form.filtering}
          data={carros}
          config={[
            {
              label: "id",
              key: "id",

              width: 50,
            },
            {
              label: "brand",
              key: "brand.name",

              width: 200,
            },
            {
              label: "Modelo",
              key: "model",
              width: 200,
            },
            {
              label: "Consumo",
              key: "consumption",
              width: 200,
            },
            {
              label: "Licencia",
              key: "license",
              width: 200,
            },
            {
              label: "Stado",
              key: "status",
              width: 200,
            },
          ]}
          actions={(carro) => (
            <Button color="blue" appearance="primary" size="xs">
              Ver informções
            </Button>
          )}
          onRowClick={(carro) => {
            dispatch(
              updateAdmin({
                behavior: "carro",
              })
            );
            setComponent("drawer_carros", true);

            dispatch(updateAdmin({ carro }));
          }}
        />
      </div>
    </div>
  </div>
  );
}
